import React from "react";
import axios, { AxiosInstance } from "axios";
import { UseSsrQueryLoadData } from "./types";

export interface SiteSsrQueryCacheitem<R=any> {
	baseKey: string,
	fullKey: string,
	load: () => Promise<R> | R,
}

export const SiteQueryContext = React.createContext<{
	axios: AxiosInstance,
	queries?: SiteSsrQueryCacheitem[],
	ssr: boolean
}>({
	axios: null,
	ssr: false
});

export interface SiteSsrQueryConfigProps {
	axios?: AxiosInstance,
	queryCache?: SiteSsrQueryCacheitem[],
	ssr?: boolean,
	children: React.ReactNode
}

export const SiteQueryConfig: React.FC<SiteSsrQueryConfigProps> = props => {
	return (
		<SiteQueryContext.Provider value={{
			axios: props.axios ?? axios,
			queries: props.queryCache,
			ssr: props.ssr
		}}>
			{props.children}
		</SiteQueryContext.Provider>
	);
}
